export default 'fonts/3e2b7a061f2610d4cade2c3711e95241.woff';